module.exports = __webpack_public_path__ + "static/media/16_plantilla_cuadrada_combo_simple_cp_aguas_pet_591_sw.dc0f0e55.png";